import { Vector2 } from "@babylonjs/core/Maths/math.vector";
import { AbstractInteractorTool } from './tools';
import { EditWallOpening } from './../cmd/EditWallOpening';
import { Util } from "../utils/Util";
import { WallOpeningInteractors } from './WallOpeningInteractors';
import { projectPointOnLine2ToRef } from '@egr/wcf/modules/core/utils/MathUtils';
export class MoveWallOpening extends AbstractInteractorTool {
    constructor(pRoomManager) {
        super(pRoomManager);
        this.mCommand = null;
        this.mDistanceFeedback = null;
    }
    initialize(pOpening, pMode = MoveOpening.Mode.Move, pPosL = null, pPosR = null) {
        this.mOpening = pOpening;
        this.mOpeningDirection = (this.mOpening.endPoint.subtract(this.mOpening.startPoint)).normalize();
        this.mCommand = new EditWallOpening(this.mRoomManager, this.mOpening);
        this.mMode = pMode;
        this.mRoomManager.beginInteraction();
        this.mPosL = pPosL;
        this.mPosR = pPosR;
        if (this.mOpening.type == "GlassFront")
            this.mSegWidth = this.mOpening.OpeningParams.ColumnWidth;
        this.mFirstMove = false;
    }
    stop() {
        if (this.mCommand != null) {
            this.mCommand.cancel();
            this.mCommand = null;
        }
        this.updateFeedback();
        this.mRoomManager.endInteraction();
        if (this.mOpening !== null)
            this.mOpening.updateGeometry();
        this.mOpening.endInteracting();
        super.stop();
    }
    //// protected /////////////////////////////////////////////////////////////////////////////
    startPos(pPos) {
        this.mStartPos = pPos;
    }
    // tslint:disable-next-line:cyclomatic-complexity
    updatePointerPosition(pPos) {
        if (this.mFirstMove) {
            this.mFirstMove = true;
            this.mOpening.beginInteracting();
        }
        if (this.mOpening.wall == null)
            return;
        let t2dPos = Util.to2d(pPos);
        if (this.mMode == MoveOpening.Mode.Move) {
            let tNearestWall = this.mRoomManager.getNearestWall(t2dPos);
            if (tNearestWall == null)
                return;
            if (tNearestWall != this.mOpening.wall) {
                this.mOpening.endInteracting();
                this.mOpening.attachToWall(tNearestWall, t2dPos);
                this.mOpening.beginInteracting();
            }
            else {
                this.mOpening.setPosition(t2dPos);
                this.mOpening.beginInteracting();
            }
        }
        if (this.mMode == MoveOpening.Mode.ScaleStart) {
            if (this.mPosL == null || this.mPosR == null)
                return;
            let t_newPos = new Vector2(0, 0);
            projectPointOnLine2ToRef(Util.to2d(pPos), this.mOpening.wall.startPoint, this.mOpening.wall.endPoint, true, t_newPos);
            this.mOpening.setStartPoint(t_newPos);
        }
        if (this.mMode == MoveOpening.Mode.ScaleEnd) {
            if (this.mPosL == null || this.mPosR == null)
                return;
            let t_newPos = new Vector2(0, 0);
            projectPointOnLine2ToRef(Util.to2d(pPos), this.mOpening.wall.startPoint, this.mOpening.wall.endPoint, true, t_newPos);
            this.mOpening.setEndPoint(t_newPos);
        }
        this.mApp.rendering.notifyModelInteraction();
        if (this.mView != null)
            this.mView.viewer.requestRenderFrame();
    }
    finish() {
        if (this.mCommand == null)
            return;
        this.mApp.commands.executeCommand(this.mCommand).then(() => {
            if (this.mOpening.type == "GlassFront")
                this.mOpening.OpeningParams.ColumnWidth = this.mSegWidth;
            this.mCommand = null;
            this.stop();
        });
    }
    prepareFeedback() {
        super.prepareFeedback();
        this.mDistanceFeedback = new WallOpeningInteractors(this.mRoomManager, this.mOpening);
        this.mDistanceFeedback._updateDistInteractors();
    }
    clearFeedback() {
        super.clearFeedback();
        if (this.mDistanceFeedback != null) {
            this.mDistanceFeedback.clear();
            this.mDistanceFeedback = null;
        }
    }
    updateFeedback() {
        super.updateFeedback();
        if (this.mDistanceFeedback != null) {
            this.mDistanceFeedback._updateDistInteractors();
            this.mDistanceFeedback._showOpeningWidthInteractors();
        }
    }
}
//add nested types
export var MoveOpening;
(function (MoveOpening) {
    let Mode;
    (function (Mode) {
        Mode[Mode["Move"] = 0] = "Move";
        Mode[Mode["ScaleEnd"] = 1] = "ScaleEnd";
        Mode[Mode["ScaleStart"] = 2] = "ScaleStart";
    })(Mode = MoveOpening.Mode || (MoveOpening.Mode = {}));
})(MoveOpening || (MoveOpening = {}));
